/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TenantFeatureSettingsEntity } from './TenantFeatureSettingsEntity.js';
import {
    TenantFeatureSettingsEntityFromJSON,
    TenantFeatureSettingsEntityFromJSONTyped,
    TenantFeatureSettingsEntityToJSON,
} from './TenantFeatureSettingsEntity.js';

/**
 * 
 * @export
 * @interface TenantSettingsConfigEntity
 */
export interface TenantSettingsConfigEntity {
    /**
     * 
     * @type {Array<TenantFeatureSettingsEntity>}
     * @memberof TenantSettingsConfigEntity
     */
    features?: Array<TenantFeatureSettingsEntity>;
}

/**
 * Check if a given object implements the TenantSettingsConfigEntity interface.
 */
export function instanceOfTenantSettingsConfigEntity(value: object): boolean {
    return true;
}

export function TenantSettingsConfigEntityFromJSON(json: any): TenantSettingsConfigEntity {
    return TenantSettingsConfigEntityFromJSONTyped(json, false);
}

export function TenantSettingsConfigEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSettingsConfigEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'features': json['features'] == null ? undefined : ((json['features'] as Array<any>).map(TenantFeatureSettingsEntityFromJSON)),
    };
}

export function TenantSettingsConfigEntityToJSON(value?: TenantSettingsConfigEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'features': value['features'] == null ? undefined : ((value['features'] as Array<any>).map(TenantFeatureSettingsEntityToJSON)),
    };
}

